import axios from 'axios';
import ApiEndpoints from '../const/ApiEndpoints';
import useProject from './Project/useProject';

export default function useModelMetaData() {
  const { user } = useProject();
  const addResultToModelMetaData = (payload) => {
    return axios
      .post(
        `${ApiEndpoints.MODULE_BASE_URL.DI + ApiEndpoints.PROJECT_MANAGEMENT.ADD_TO_MMD}`,
        payload
      )
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };

  const fetchModelMetaDataSchema = (payload) => {
    return axios
      .get(
        `${ApiEndpoints.MODULE_BASE_URL.DI + ApiEndpoints.PROJECT_MANAGEMENT.FETCH_MMD_SCHEMA}`,
        {
          params: {
            project_id: payload.project_id,
            project_type: payload.type,
            username: user?.userData?.username,
          },
        }
      )
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };

  const fetchModelMetaData = (payload) => {
    return axios
      .get(
        `${ApiEndpoints.MODULE_BASE_URL.DI + ApiEndpoints.PROJECT_MANAGEMENT.FETCH_MMD_DATA}`,
        {
          params: {
            project_id: payload.project_id,
          },
        }
      )
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };

  const updateModelMetaData = (payload) => {
    return axios
      .post(
        `${ApiEndpoints.MODULE_BASE_URL.DI + ApiEndpoints.PROJECT_MANAGEMENT.ADD_TO_MMD}`,
        payload
      )
      .then(
        (res) => {
          return res;
        },
        (error) => {
          throw error;
        }
      );
  };

  return {
    addResultToModelMetaData,
    fetchModelMetaDataSchema,
    fetchModelMetaData,
    updateModelMetaData,
  };
}
